module.exports = __webpack_public_path__ + "img/aoc.ee227cde.webp";